const articleTypes = {
    general: 'general',
    unsigned: 'unsigned',
    discover: 'discover'
};

export default articleTypes;